import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g><circle cx=\"2.5\" cy=\"4\" r=\"2.5\" fill=\"currentColor\"></circle><path d=\"M8.5,5H23a1,1,0,0,0,0-2H8.5a1,1,0,0,0,0,2Z\" fill=\"currentColor\"></path><circle cx=\"2.5\" cy=\"12\" r=\"2.5\" fill=\"currentColor\"></circle><path d=\"M23,11H8.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z\" fill=\"currentColor\"></path><circle cx=\"2.5\" cy=\"20\" r=\"2.5\" fill=\"currentColor\"></circle><path d=\"M23,19H8.5a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z\" fill=\"currentColor\"></path></g>", 1)
  ])))
}
export default { render: render }